//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteMNP from './expedienteMateriasNP'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteMNP />
            </div>
        );
    }

}
export default Index;